import React, { useState } from 'react'
import Layout from '../components/common/Layout'
import Feedback from '../components/contact/Feedback'

const FeedbackPage = () => {
  return (
    <Layout
      meta={{
        description:
          'Dedicated support team to help you get started with Atlas. Get in touch with us to learn more about Atlas. We are here to help.',
        title: 'Feedback',
        absoluteImageUrl: 'https://atlas.co/images/default-og.png',
        type: 'website'
      }}
      title={'Feedback'}
    >
      <main>
        <Feedback />
      </main>
    </Layout>
  )
}

export default FeedbackPage
